// import React, { useState, useEffect } from 'react';
// import { Search, ShieldCheck, GraduationCap, Key, Calendar, X, Loader2, ClipboardCheck, ToggleLeft, ToggleRight } from 'lucide-react';

// export default function StudentManagement() {
//   const sessionUser = JSON.parse(sessionStorage.getItem('userSession')) || { id: 1, name: "Staff", role: "counsellor" };

//   const [activeTab, setActiveTab] = useState('all'); 
//   const [students, setStudents] = useState([]);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [tableLoading, setTableLoading] = useState(false);
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 5;

//   // Modal Popup Windows Status Triggers
//   const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
//   const [isTermModalOpen, setIsTermModalOpen] = useState(false);
  
//   const [selectedStudent, setSelectedStudent] = useState(null);
//   const [generatedCreds, setGeneratedCreds] = useState(null);

//   const [coursesList, setCoursesList] = useState([]); // ➕ Dynamic Courses State

//   const [termForm, setTermForm] = useState({ targetCourse: 'React FullStack', nextSemester: 'Semester 1', nextAcademicYear: '2026-2027' });

//   // 💻 Simple English Navigation Tab Configuration Array List Matrix
//   const simpleTabs = [
//     { id: 'all', name: 'Manage Students & Records', icon: GraduationCap },
//     { id: 'pending_auth', name: 'Generate Portal Credentials', icon: Key },
//     { id: 'active_auth', name: 'Active Login Accounts', icon: ShieldCheck }
//   ];

//   useEffect(() => {
//     fetchStudents();
//     setCurrentPage(1);
//   }, [activeTab, searchTerm]);


//   // ➕ Fetch dynamic courses from API
//   useEffect(() => {
//     const fetchCoursesList = async () => {
//       try {
//         const res = await fetch('https://metapi.emedhatechnologies.com/api/courses/courses');
//         const data = await res.json();
//         if (data.success && data.data.length > 0) {
//           setCoursesList(data.data);
//           // Set default targetCourse to the first course from API
//           setTermForm((prev) => ({
//             ...prev,
//             targetCourse: data.data[0].course_name.trim(),
//           }));
//         }
//       } catch (err) {
//         console.error("Failed to load course options:", err);
//       }
//     };
//     fetchCoursesList();
//   }, []);

//   const fetchStudents = async () => {
//     setTableLoading(true);
//     try {
//       const res = await fetch(`https://metapi.emedhatechnologies.com/api/students?tabStatus=${activeTab}&search=${encodeURIComponent(searchTerm)}&userId=${sessionUser.id}&userRole=${sessionUser.role}`);
//       const result = await res.json();
//       if (result.success) setStudents(result.data);
//     } catch (err) {
//       console.error(err);
//     } finally {
//       setTableLoading(false);
//     }
//   };

//   const handleCreateCredentialsClick = (student) => {
//     setSelectedStudent(student);
//     const user = `${student.name.toLowerCase().replace(/\s+/g, '')}${student.id}`;
//     const pass = `MET@${Math.floor(1000 + Math.random() * 9000)}`;
//     setGeneratedCreds({ username: user, password: pass });
//     setIsAuthModalOpen(true);
//   };

//   const saveCredentialsToDatabase = async () => {
//     try {
//       const res = await fetch(`https://metapi.emedhatechnologies.com/api/students/provision-auth/${selectedStudent.id}`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ ...generatedCreds })
//       });
//       if ((await res.json()).success) {
//         setIsAuthModalOpen(false);
//         setGeneratedCreds(null);
//         fetchStudents();
//       }
//     } catch (err) { console.error(err); }
//   };

//   // 💻 Instant Status Switch Trigger Action (Active / Inactive Account Switcher Tooler)
//   const handleToggleAccountAccess = async (studentId, currentActiveState) => {
//     try {
//       const res = await fetch(`https://metapi.emedhatechnologies.com/api/students/toggle-status/${studentId}`, {
//         method: 'PATCH',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ makeActive: !currentActiveState })
//       });
//       if ((await res.json()).success) {
//         fetchStudents();
//       }
//     } catch (err) { console.error("Failed to alter access configuration state flag:", err); }
//   };

//   const handleTermAssignmentSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       const res = await fetch('https://metapi.emedhatechnologies.com/api/students/advance-term', {
//         method: 'PUT',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ ...termForm, sessionUser })
//       });
//       if ((await res.json()).success) {
//         setIsTermModalOpen(false);
//         fetchStudents();
//       }
//     } catch (err) { console.error(err); }
//   };

//   const totalPages = Math.ceil(students.length / itemsPerPage) || 1;
//   const currentItems = students.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

//   return (
//     <div>
//       {/* STEP 1: NAVIGATION AND ACTION HEADER ROW */}
//       <div style={styles.topActionBar}>
//         <div style={styles.tabScrollGroup}>
//           {simpleTabs.map((tab) => {
//             const Icon = tab.icon;
//             return (
//               <button key={tab.id} onClick={() => setActiveTab(tab.id)} style={{ ...styles.tabBtn, ...(activeTab === tab.id ? styles.tabBtnActive : {}) }}>
//                 <Icon size={15} style={{ marginRight: '6px' }} /> {tab.name}
//               </button>
//             );
//           })}
//         </div>
//         <button onClick={() => setIsTermModalOpen(true)} style={styles.termAdvanceBtn}>
//           <Calendar size={15} style={{ marginRight: '6px' }} /> Assign Year & Semester
//         </button>
//       </div>

//       {/* STEP 2: SEARCH FILTERS PANEL */}
//       <div style={styles.filterControlPanel}>
//         <div style={styles.searchWrapper}>
//           <Search size={16} style={styles.searchIcon} />
//           <input type="text" placeholder="Search student records..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} style={styles.tableSearchInput} />
//         </div>
//         <div style={styles.totalIndicator}>Total Students Listed: <strong style={{ color: '#459bf2' }}>{students.length}</strong></div>
//       </div>

//       {/* STEP 3: MASTER DATA GRID TABLE WITH HORIZONTAL PACKING CONTROLS */}
//       {tableLoading ? (
//         <div style={{ display: 'flex', justifyContent: 'center', padding: '40px' }}><Loader2 size={32} style={{ animation: 'spin 1s linear infinite' }} color="#459bf2" /></div>
//       ) : (
//         <div style={{ overflowX: 'auto', width: '100%' }}>
//           <table style={styles.dataTable}>
//             <thead>
//               <tr>
//                 <th style={styles.tableTh}>Admission No.</th>
//                 <th style={styles.tableTh}>Student Full Name</th>
//                 <th style={styles.tableTh}>Contact Mobile</th>
//                 <th style={styles.tableTh}>Assigned Course</th>
//                 <th style={styles.tableTh}>College Name / Campus</th>
//                 <th style={styles.tableTh}>Highest Qualification</th>
//                 <th style={styles.tableTh}>Aadhaar Number</th>
//                 <th style={styles.tableTh}>Academic Year & Semester</th>
//                 <th style={styles.tableTh}>Created By</th>
//                 {/* 💻 Updated headers to display simple indicator columns */}
//                 <th style={styles.tableTh}>Credential Status</th>
//                 <th style={styles.tableTh}>System Login Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {currentItems.map((std) => (
//                 <tr key={std.id} style={std.is_account_active === 0 ? styles.tableTrDisabled : styles.tableTr}>
//                   <td style={{ ...styles.tableTd, fontWeight: '700', color: '#0f172a' }}>{std.roll_number || `MET-ADM-${std.id}`}</td>
//                   <td style={styles.tableTd}><strong>{std.name}</strong><br/><small style={{ color: '#64748b' }}>{std.email}</small></td>
//                   <td style={styles.tableTd}>{std.mobile}</td>
//                   <td style={styles.tableTd}><span style={styles.courseBadge}>{std.target_course}</span></td>
//                   <td style={styles.tableTd}>{std.college_university}</td>
//                   <td style={styles.tableTd}>{std.highest_qualification || 'XII'}</td>
//                   <td style={styles.tableTd}>[Aadhaar Redacted]</td>
//                   <td style={styles.tableTd}>
//                     <div style={{ fontWeight: '600', color: '#334155' }}>{std.current_semester}</div>
//                     <div style={{ fontSize: '11px', color: '#64748b', marginTop: '2px' }}>Academic Year: {std.academic_year}</div>
//                   </td>
//                   <td style={styles.tableTd}><span style={{ fontSize: '12px', fontWeight: '500' }}>{std.created_by_name}</span></td>
                  
//                   {/* Column A: Display current setup state directly using simple text */}
//                   <td style={styles.tableTd}>
//                     {std.login_access_provisioned === 1 ? (
//                       <span style={std.is_account_active === 1 ? styles.secureBadge : styles.inactiveBadge}>
//                         {std.is_account_active === 1 ? "Account Live" : "Account Suspended"}
//                       </span>
//                     ) : (
//                       <span style={styles.pendingBadge}>Pending Setup</span>
//                     )}
//                   </td>

//                   {/* Column B: Dynamic login access options based on execution rules */}
//                   <td style={styles.tableTd}>
//                     <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
//                       {std.login_access_provisioned === 0 ? (
//                         // If account doesn't exist yet, show creation trigger option
//                         <button onClick={() => handleCreateCredentialsClick(std)} style={styles.provisionBtn}>Create Logins</button>
//                       ) : (
//                         // If account exists, render access control state switches
//                         <button 
//                           onClick={() => handleToggleAccountAccess(std.id, std.is_account_active === 1)}
//                           style={std.is_account_active === 1 ? styles.deactivateBtn : styles.activateBtn}
//                         >
//                           {std.is_account_active === 1 ? "Deactivate Access" : "Activate Access"}
//                         </button>
//                       )}
//                     </div>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       )}

//       {/* STEP 4: PAGINATION BAR CONTAINER */}
//       <div style={styles.paginationBar}>
//         <span style={{ color: '#64748b', fontSize: '13px' }}>Page {currentPage} of {totalPages}</span>
//         <div style={{ display: 'flex', gap: '8px' }}>
//           <button disabled={currentPage === 1} onClick={() => setCurrentPage(currentPage - 1)} style={{ ...styles.pagBtn, ...(currentPage === 1 && styles.pagBtnDisabled) }}>Previous</button>
//           <button disabled={currentPage === totalPages} onClick={() => setCurrentPage(currentPage + 1)} style={{ ...styles.pagBtn, ...(currentPage === totalPages && styles.pagBtnDisabled) }}>Next</button>
//         </div>
//       </div>

//       {/* MODAL 1: LOGIN PROVISIONING INTERACTIVE POPUP */}
//       {isAuthModalOpen && (
//         <div style={styles.modalBackdrop}>
//           <div style={{ ...styles.modalWrapperCard, maxWidth: '420px' }}>
//             <div style={styles.modalHeader}>
//               <h3 style={{ margin: 0, fontSize: '15px' }}>Student Login Created</h3>
//               <button onClick={() => setIsAuthModalOpen(false)} style={styles.modalCloseX}><X size={18} /></button>
//             </div>
//             <div style={{ padding: '16px 0', display: 'flex', flexDirection: 'column', gap: '12px' }}>
//               <p style={{ fontSize: '13.5px', color: '#475569', margin: 0 }}>Logins ready for: <strong>{selectedStudent?.name}</strong></p>
//               <div style={styles.credsContainerBox}>
//                 <div style={styles.credRow}><span>Student Username:</span> <strong>{generatedCreds?.username}</strong></div>
//                 <div style={styles.credRow}><span>Default Password:</span> <strong>{generatedCreds?.password}</strong></div>
//               </div>
//               <button onClick={() => { navigator.clipboard.writeText(`User: ${generatedCreds.username} | Pass: ${generatedCreds.password}`); alert("Copied!"); }} style={styles.copyBtn}><ClipboardCheck size={14} /> Copy Credentials</button>
//             </div>
//             <div style={styles.formActionDock}>
//               <button onClick={() => setIsAuthModalOpen(false)} style={styles.formCancelBtn}>Cancel</button>
//               <button onClick={saveCredentialsToDatabase} style={styles.formSaveBtn}>Activate Access Account</button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* MODAL 2: ASSIGN ACADEMIC YEAR & SEMESTER MODAL */}
//       {isTermModalOpen && (
//         <div style={styles.modalBackdrop}>
//           <div style={styles.modalWrapperCard}>
//             <div style={styles.modalHeader}>
//               <h3 style={{ margin: 0, fontSize: '15px' }}>Assign Academic Year & Semester Settings</h3>
//               <button onClick={() => setIsTermModalOpen(false)} style={styles.modalCloseX}><X size={18} /></button>
//             </div>
//             <form onSubmit={handleTermAssignmentSubmit} style={styles.modalForm}>
//               <div style={styles.formSplitGrid}>
// <div style={styles.fieldContainer}>
//   <label style={styles.fieldLabel}>Select Target Course</label>
//   <select 
//     value={termForm.targetCourse} 
//     onChange={(e) => setTermForm({ ...termForm, targetCourse: e.target.value })} 
//     style={styles.formSelect}
//   >
//     {coursesList.length === 0 ? (
//       <option value="">Loading courses...</option>
//     ) : (
//       coursesList.map((course) => (
//         <option key={course.id} value={course.course_name.trim()}>
//           {course.course_name.trim()}
//         </option>
//       ))
//     )}
//   </select>
// </div>
//                 <div style={styles.fieldContainer}>
//                   <label style={styles.fieldLabel}>Assign to Semester</label>
//                   <select value={termForm.nextSemester} onChange={(e) => setTermForm({ ...termForm, nextSemester: e.target.value })} style={styles.formSelect}>
//                     <option>Semester 1</option><option>Semester 2</option><option>Semester 3</option><option>Semester 4</option><option>Semester 5</option><option>Semester 6</option><option>Semester 7</option><option>Semester 8</option>
//                   </select>
//                 </div>
//               </div>
//               <div style={styles.fieldContainer}><label style={styles.fieldLabel}>Assign Academic Year</label><input type="text" required value={termForm.nextAcademicYear} onChange={(e) => setTermForm({ ...termForm, nextAcademicYear: e.target.value })} style={styles.formInput} placeholder="e.g. 2026-2027" /></div>
//               <div style={styles.formActionDock}>
//                 <button type="button" onClick={() => setIsTermModalOpen(false)} style={styles.formCancelBtn}>Cancel</button>
//                 <button type="submit" style={{ ...styles.formSaveBtn, background: 'linear-gradient(90deg, #459bf2 0%, #1c6ec9 100%)' }}>Save Academic Setup</button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// // STYLING STRUCTURE CONFIGURATIONS GRID SHEET ANCHORS MATRIX MAPS
// const styles = {
//   topActionBar: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '16px', marginBottom: '20px', flexWrap: 'wrap' },
//   tabScrollGroup: { display: 'flex', gap: '8px', overflowX: 'auto', paddingBottom: '4px' },
//   tabBtn: { display: 'inline-flex', alignItems: 'center', padding: '10px 16px', background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '10px', color: '#64748b', fontSize: '13.5px', fontWeight: '500', cursor: 'pointer', whiteSpace: 'nowrap', transition: 'all 0.2s' },
//   tabBtnActive: { background: 'linear-gradient(135deg, #459bf2 0%, #1c6ec9 100%)', borderColor: '#459bf2', color: '#ffffff', boxShadow: '0 4px 12px rgba(69, 155, 242, 0.15)' },
//   termAdvanceBtn: { background: 'linear-gradient(90deg, #e30504 0%, #a80302 100%)', border: 'none', borderRadius: '12px', color: '#fff', padding: '12px 20px', fontSize: '13px', fontWeight: '700', cursor: 'pointer', display: 'flex', alignItems: 'center', whiteSpace: 'nowrap' },
//   filterControlPanel: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '16px', marginBottom: '16px', flexWrap: 'wrap', borderBottom: '1px solid #edf2f7', paddingBottom: '14px' },
//   searchWrapper: { position: 'relative', display: 'flex', alignItems: 'center', flex: 1, maxWidth: '300px', width: '100%' },
//   searchIcon: { position: 'absolute', left: '12px', color: '#94a3b8' },
//   tableSearchInput: { width: '100%', padding: '9px 12px 9px 36px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '9px', color: '#0f172a', fontSize: '13.5px', outline: 'none' },
//   totalIndicator: { fontSize: '14.5px', fontWeight: '600', color: '#334155' },
//   dataTable: { width: '100%', borderCollapse: 'collapse', textAlign: 'left' },
//   tableTh: { padding: '12px 14px', borderBottom: '2px solid #e2e8f0', color: '#64748b', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.5px', fontWeight: '600', whiteSpace: 'nowrap' },
//   tableTr: { borderBottom: '1px solid #f1f5f9', background: '#ffffff' },
//   tableTrDisabled: { borderBottom: '1px solid #f1f5f9', background: '#fff1f2', opacity: 0.85 },
//   tableTd: { padding: '12px 14px', color: '#475569', fontSize: '13px', verticalAlign: 'middle', whiteSpace: 'nowrap' },
//   courseBadge: { background: '#eff6ff', border: '1px solid #bfdbfe', color: '#1e40af', padding: '4px 8px', borderRadius: '6px', fontSize: '12px', fontWeight: '500', display: 'inline-block' },
  
//   // Clean custom status indicators tags using plain language color models
//   secureBadge: { display: 'inline-flex', padding: '4px 8px', background: '#dcfce7', border: '1px solid #bbf7d0', color: '#15803d', borderRadius: '6px', fontSize: '11.5px', fontWeight: '600' },
//   inactiveBadge: { display: 'inline-flex', padding: '4px 8px', background: '#fee2e2', border: '1px solid #fecaca', color: '#b91c1c', borderRadius: '6px', fontSize: '11.5px', fontWeight: '600' },
//   pendingBadge: { display: 'inline-flex', padding: '4px 8px', background: '#f1f5f9', border: '1px solid #cbd5e1', color: '#475569', borderRadius: '6px', fontSize: '11.5px', fontWeight: '600' },
  
//   provisionBtn: { background: '#ffffff', border: '1px solid #94a3b8', color: '#1e40af', padding: '5px 10px', borderRadius: '6px', fontSize: '11.5px', fontWeight: '600', cursor: 'pointer' },
//   activateBtn: { background: '#dcfce7', border: 'none', color: '#15803d', padding: '5px 10px', borderRadius: '6px', fontSize: '11.5px', fontWeight: '600', cursor: 'pointer' },
//   deactivateBtn: { background: '#fee2e2', border: 'none', color: '#b91c1c', padding: '5px 10px', borderRadius: '6px', fontSize: '11.5px', fontWeight: '600', cursor: 'pointer' },
  
//   paginationBar: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '20px' },
//   pagBtn: { background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '8px', color: '#475569', padding: '6px 14px', fontSize: '13px', cursor: 'pointer', fontWeight: '500' },
//   pagBtnDisabled: { opacity: 0.4, cursor: 'not-allowed', background: '#f8fafc' },
//   modalBackdrop: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(15, 23, 42, 0.25)', backdropFilter: 'blur(8px)', zIndex: 2000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' },
//   modalWrapperCard: { background: '#ffffff', border: '1px solid rgba(255,255,255,0.8)', borderRadius: '20px', width: '100%', maxWidth: '580px', maxHeight: '85vh', padding: '24px', display: 'flex', flexDirection: 'column', boxSizing: 'border-box', boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.05)' },
//   modalHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBottom: '12px', borderBottom: '1px solid #e2e8f0' },
//   modalCloseX: { background: 'transparent', border: 'none', color: '#94a3b8', cursor: 'pointer' },
//   modalForm: { display: 'flex', flexDirection: 'column', gap: '14px', marginTop: '14px' },
//   formSplitGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' },
//   fieldContainer: { display: 'flex', flexDirection: 'column', gap: '4px' },
//   fieldLabel: { color: '#64748b', fontSize: '11px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px' },
//   formInput: { width: '100%', padding: '10px 12px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '8px', color: '#0f172a', fontSize: '13px', outline: 'none', boxSizing: 'border-box' },
//   formSelect: { padding: '10px 12px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '8px', color: '#0f172a', fontSize: '13px', outline: 'none' },
//   credsContainerBox: { background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '12px', padding: '12px', display: 'flex', flexDirection: 'column', gap: '6px' },
//   credRow: { display: 'flex', justifyContent: 'space-between', fontSize: '13.5px', color: '#334155' },
//   copyBtn: { display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '6px', background: '#f1f5f9', border: '1px solid #cbd5e1', padding: '8px', borderRadius: '8px', fontSize: '12px', fontWeight: '600', color: '#475569', cursor: 'pointer' },
//   formActionDock: { display: 'flex', justifyContent: 'flex-end', gap: '12px', marginTop: '8px', borderTop: '1px solid #e2e8f0', paddingTop: '12px' },
//   formCancelBtn: { background: 'transparent', border: '1px solid #e2e8f0', color: '#64748b', padding: '9px 16px', borderRadius: '8px', cursor: 'pointer' },
//   formSaveBtn: { background: 'linear-gradient(90deg, #10b981 0%, #059669 100%)', border: 'none', color: '#fff', padding: '9px 16px', borderRadius: '8px', fontWeight: '600', cursor: 'pointer' }
// };




import React, { useState, useEffect } from 'react';
import { Search, ShieldCheck, GraduationCap, Key, Calendar, X, Loader2, ClipboardCheck, BookOpen, FileText, Plus, Trash2, Edit3, Check, Upload, ClipboardList } from 'lucide-react';

export default function StudentManagement() {
  const sessionUser = JSON.parse(sessionStorage.getItem('userSession')) || { id: 1, name: "Staff", role: "counsellor" };

  const [activeTab, setActiveTab] = useState('all');
  const [students, setStudents] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [tableLoading, setTableLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  // Modal Popup Windows Status Triggers
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
  const [isTermModalOpen, setIsTermModalOpen] = useState(false);
  const [isBooksModalOpen, setIsBooksModalOpen] = useState(false);
  const [isDocsModalOpen, setIsDocsModalOpen] = useState(false);

  // Student specific modal data states for Books
  const [studentBooks, setStudentBooks] = useState([]);
  const [isAddingBook, setIsAddingBook] = useState(false);

  const [editingBookId, setEditingBookId] = useState(null);


  // State for adding a new book dispatch
const [newBookForm, setNewBookForm] = useState({ 
  course_name: '', 
  term_label: 'Semester 1', 
  sent_date: new Date().toISOString().substring(0, 10), 
  courier_details: '', 
  enquiryDetails: '' 
});

// State for editing a book dispatch
const [editBookForm, setEditBookForm] = useState({ 
  course_name: '', 
  term_label: 'Semester 1', 
  sent_date: '', 
  courier_details: '', 
  enquiry_details: '' 
});


const [isAssignmentsModalOpen, setIsAssignmentsModalOpen] = useState(false);
const [studentAssignments, setStudentAssignments] = useState([]);
const [isAddingAssignment, setIsAddingAssignment] = useState(false);
const [editingAssignmentId, setEditingAssignmentId] = useState(null);

const [newAssignmentForm, setNewAssignmentForm] = useState({
  course_name: '',
  term_label: 'Semester 1',
  project_title: '',
  submission_date: new Date().toISOString().substring(0, 10),
  is_completed: true,
  remarks: ''
});

  // Student specific modal data states for Documents
  const [studentDocs, setStudentDocs] = useState([]);
  const [isAddingDoc, setIsAddingDoc] = useState(false);
  const [newDocForm, setNewDocForm] = useState({ name: '', type: 'PDF', status: 'Verified', fileName: '' });
  const [editingDocId, setEditingDocId] = useState(null);
  const [editDocForm, setEditDocForm] = useState({ name: '', type: 'PDF', status: 'Verified', fileName: '' });

  const [selectedStudent, setSelectedStudent] = useState(null);
  const [generatedCreds, setGeneratedCreds] = useState(null);
  const [termForm, setTermForm] = useState({ targetCourse: 'React FullStack', nextSemester: 'Semester 1', nextAcademicYear: '2026-2027' });

  const simpleTabs = [
    { id: 'all', name: 'Manage Students & Records', icon: GraduationCap },
    { id: 'pending_auth', name: 'Generate Portal Credentials', icon: Key },
    { id: 'active_auth', name: 'Active Login Accounts', icon: ShieldCheck }
  ];

  useEffect(() => {
    fetchStudents();
    setCurrentPage(1);
  }, [activeTab, searchTerm]);

  const fetchStudents = async () => {
    setTableLoading(true);
    try {
      const res = await fetch(`https://metapi.emedhatechnologies.com/api/students?tabStatus=${activeTab}&search=${encodeURIComponent(searchTerm)}&userId=${sessionUser.id}&userRole=${sessionUser.role}`);
      const result = await res.json();
      if (result.success) setStudents(result.data);
    } catch (err) {
      console.error(err);
    } finally {
      setTableLoading(false);
    }
  };

  const handleCreateCredentialsClick = (student) => {
    setSelectedStudent(student);
    const user = `${student.name.toLowerCase().replace(/\s+/g, '')}${student.id}`;
    const pass = `MET@${Math.floor(1000 + Math.random() * 9000)}`;
    setGeneratedCreds({ username: user, password: pass });
    setIsAuthModalOpen(true);
  };

  // const saveCredentialsToDatabase = async () => {
  //   try {
  //     const res = await fetch(`https://metapi.emedhatechnologies.com/api/students/provision-auth/${selectedStudent.id}`, {
  //       method: 'POST',
  //       headers: { 'Content-Type': 'application/json' },
  //       body: JSON.stringify({ ...generatedCreds })
  //     });
  //     if ((await res.json()).success) {
  //       setIsAuthModalOpen(false);
  //       setGeneratedCreds(null);
  //       fetchStudents();
  //     }
  //   } catch (err) { console.error(err); }
  // };


const saveCredentialsToDatabase = async () => {
  // 1. Clean and format the student's mobile number
  let rawMobile = (selectedStudent?.mobile || '').replace(/\D/g, '');
  if (rawMobile.length === 10) {
    rawMobile = '91' + rawMobile;
  }

  // 2. Format the portal credentials WhatsApp message template
  const studentAdmissionNo = selectedStudent?.adm_number || selectedStudent?.roll_number || `MET-ADM-${selectedStudent?.id}`;
  const targetCourse = selectedStudent?.target_course || 'Academic Program';

  const messageBody = 
`🔐 *MET Academy - Student Portal Credentials*

Dear *${selectedStudent?.name}*,

Your student portal account has been successfully provisioned. You can now log in to access your course materials, hall tickets, and academic updates.

📋 *Admission No:* ${studentAdmissionNo}
🎓 *Course:* ${targetCourse}
🌐 *Portal URL:* https://metstudent.emedhatechnologies.com
👤 *Username:* ${generatedCreds?.username}
🔑 *Password:* ${generatedCreds?.password}

⚠️ *Note:* Please keep your credentials secure and change your password upon your first login.

Warm Regards,
*MET Academy Support Team*`;

  // 3. Open WhatsApp immediately with the pre-filled URL (Zero browser popup block)
  if (rawMobile && rawMobile.length >= 10) {
    const waUrl = `https://api.whatsapp.com/send?phone=${rawMobile}&text=${encodeURIComponent(messageBody)}`;
    window.open(waUrl, '_blank', 'noopener,noreferrer');
  } else {
    alert("Warning: Student mobile number is missing or invalid. Saving credentials without opening WhatsApp.");
  }

  // 4. Save the generated credentials to the database backend
  try {
    const res = await fetch(`https://metapi.emedhatechnologies.com/api/students/provision-auth/${selectedStudent.id}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ...generatedCreds })
    });
    
    const result = await res.json();

    if (result.success) {
      setIsAuthModalOpen(false);
      setGeneratedCreds(null);
      fetchStudents();
    } else {
      console.error("Backend error provisioning credentials:", result.message);
      alert("Failed to save credentials to database: " + (result.message || "Unknown error"));
    }
  } catch (err) {
    console.error("Failed to provision student credentials:", err);
    alert("Network error occurred while saving credentials.");
  }
};


  const handleToggleAccountAccess = async (studentId, currentActiveState) => {
    try {
      const res = await fetch(`https://metapi.emedhatechnologies.com/api/students/toggle-status/${studentId}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ makeActive: !currentActiveState })
      });
      if ((await res.json()).success) {
        fetchStudents();
      }
    } catch (err) { console.error(err); }
  };

  const handleTermAssignmentSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch('https://metapi.emedhatechnologies.com/api/students/advance-term', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...termForm, sessionUser })
      });
      if ((await res.json()).success) {
        setIsTermModalOpen(false);
        fetchStudents();
      }
    } catch (err) { console.error(err); }
  };





const handleOpenAssignmentsModal = async (student) => {
  setSelectedStudent(student);
  setIsAddingAssignment(false);
  setEditingAssignmentId(null);

  const studentCourses = student.target_course 
    ? student.target_course.split(',').map(c => c.trim()) 
    : ['General Course'];

  setNewAssignmentForm({
    course_name: studentCourses[0],
    term_label: 'Semester 1',
    project_title: '',
    submission_date: new Date().toISOString().substring(0, 10),
    is_completed: true,
    remarks: ''
  });

  setIsAssignmentsModalOpen(true);
  try {
    const res = await fetch(`https://metapi.emedhatechnologies.com/api/students/get/assignments?studentId=${student.id}`);
    const result = await res.json();
    if (result.success) {
      setStudentAssignments(result.data);
    }
  } catch (err) {
    console.error("Failed to fetch assignments:", err);
  }
};

const handleAddAssignmentSubmit = async (e) => {
  e.preventDefault();
  try {
    const payload = {
      student_id: selectedStudent.id,
      course_name: newAssignmentForm.course_name,
      term_label: newAssignmentForm.term_label,
      project_title: newAssignmentForm.project_title,
      submission_date: newAssignmentForm.submission_date,
      is_completed: newAssignmentForm.is_completed,
      remarks: newAssignmentForm.remarks,
      posted_by_user_id: sessionUser.id,
      posted_by_name: sessionUser.name,
      posted_by_role: sessionUser.role
    };

    const res = await fetch('https://metapi.emedhatechnologies.com/api/students/post/assignments', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });
    const result = await res.json();
    if (result.success) {
      setIsAddingAssignment(false);
      handleOpenAssignmentsModal(selectedStudent);
    }
  } catch (err) {
    console.error("Failed to add assignment:", err);
  }
};

const handleDeleteAssignment = async (assignmentId) => {
  if (!window.confirm("Are you sure you want to delete this assignment record?")) return;
  try {
    const res = await fetch(`https://metapi.emedhatechnologies.com/api/students/delete/assignments/${assignmentId}`, {
      method: 'DELETE'
    });
    const result = await res.json();
    if (result.success) {
      handleOpenAssignmentsModal(selectedStudent);
    }
  } catch (err) {
    console.error("Failed to delete assignment:", err);
  }
};





  // --- INTEGRATED BOOK MODAL HANDLERS ---
const handleOpenBooksModal = async (student) => {
  setSelectedStudent(student);
  setIsAddingBook(false);
  setEditingBookId(null);

  // Extract student's target courses array cleanly
  const studentCourses = student.target_course 
    ? student.target_course.split(',').map(c => c.trim()) 
    : ['General Course'];

  const initialCourse = studentCourses[0];

  setNewBookForm({
    course_name: initialCourse,
    term_label: 'Semester 1',
    sent_date: new Date().toISOString().substring(0, 10),
    courier_details: '',
    enquiryDetails: ''
  });

  setIsBooksModalOpen(true);
  try {
    const res = await fetch(`https://metapi.emedhatechnologies.com/api/students/get/books?studentId=${student.id}`);
    const result = await res.json();
    if (result.success) {
      setStudentBooks(result.data);
    }
  } catch (err) {
    console.error("Failed to fetch books:", err);
  }
};



// const handleAddBookSubmit = async (e) => {
//   e.preventDefault();
//   try {
//     const payload = {
//       student_id: selectedStudent.id,
//       course_name: newBookForm.course_name,
//       term_label: newBookForm.term_label,
//       sent_date: newBookForm.sent_date,
//       courier_details: newBookForm.courier_details,
//       enquiry_details: newBookForm.enquiryDetails || 'Book Materials Dispatched',
//       posted_by_user_id: sessionUser.id,
//       posted_by_name: sessionUser.name,
//       posted_by_role: sessionUser.role
//     };
//     const res = await fetch('https://metapi.emedhatechnologies.com/api/students/post/books', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify(payload)
//     });
//     const result = await res.json();
//     if (result.success) {
//       setIsAddingBook(false);
//       handleOpenBooksModal(selectedStudent);
//       alert("Dispatch record logged successfully!");

//       // ⚡ THIS IS CRITICAL: If the URL exists, open it in a new window/tab
//       if (result.whatsapp_url) {
//         console.log("Opening WhatsApp URL:", result.whatsapp_url);
//         window.open(result.whatsapp_url, '_blank');
//       } else {
//         console.warn("No WhatsApp URL returned by server.");
//       }
//     }
//   } catch (err) {
//     console.error("Failed to add book dispatch:", err);
//   }
// };




const handleAddBookSubmit = async (e) => {
  e.preventDefault();

  // 1. Clean and format the student's mobile number
  let rawMobile = (selectedStudent?.mobile || '').replace(/\D/g, '');
  if (rawMobile.length === 10) {
    rawMobile = '91' + rawMobile;
  }

  // 2. Format the dispatch message template directly on frontend
  const dispatchDate = newBookForm.sent_date || new Date().toISOString().substring(0, 10);
  const targetCourse = newBookForm.course_name || selectedStudent?.target_course || 'Academic Course';
  
  const messageBody = 
`📦 *Study Material Dispatched - MET Academy*

Dear *${selectedStudent?.name}*,

Your academic study materials & books have been successfully dispatched. Here are your tracking details:

📋 *Admission No:* ${selectedStudent?.adm_number || selectedStudent?.roll_number || `MET-ADM-${selectedStudent?.id}`}
🎓 *Course:* ${targetCourse}
📅 *Term / Year:* ${newBookForm.term_label}
🏢 *University:* ${selectedStudent?.college_university || 'MET Academy'}
${selectedStudent?.university_adm_number ? `🔖 *Univ. Reg No:* ${selectedStudent.university_adm_number}\n` : ''}🚚 *Dispatch Date:* ${dispatchDate}
📦 *Courier Details / Tracking:* ${newBookForm.courier_details || 'Handed to Courier Partner'}
📝 *Notes:* ${newBookForm.enquiryDetails || 'Materials Dispatched via Courier'}

If you have any questions regarding your package, please contact the MET Academy support desk.

Warm Regards,
*MET Academy Support Team*`;

  // 3. Open WhatsApp Web immediately with the pre-filled URL (Zero browser block)
  if (rawMobile && rawMobile.length >= 10) {
    const waUrl = `https://api.whatsapp.com/send?phone=${rawMobile}&text=${encodeURIComponent(messageBody)}`;
    window.open(waUrl, '_blank', 'noopener,noreferrer');
  } else {
    alert("Warning: Student mobile number is missing or invalid. Saving record without opening WhatsApp.");
  }

  // 4. Save the dispatch details to your MySQL backend
  try {
    const payload = {
      student_id: selectedStudent.id,
      course_name: targetCourse,
      term_label: newBookForm.term_label,
      sent_date: dispatchDate,
      courier_details: newBookForm.courier_details,
      enquiry_details: newBookForm.enquiryDetails || 'Book Materials Dispatched',
      posted_by_user_id: sessionUser.id,
      posted_by_name: sessionUser.name,
      posted_by_role: sessionUser.role
    };

    const res = await fetch('https://metapi.emedhatechnologies.com/api/students/post/books', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });

    const result = await res.json();

    if (result.success) {
      setIsAddingBook(false);
      handleOpenBooksModal(selectedStudent);
    } else {
      console.error("Backend error logging book dispatch:", result.message);
    }
  } catch (err) {
    console.error("Failed to save book dispatch to backend:", err);
  }
};

  const handleStartEditBook = (book) => {
    setEditingBookId(book.id);
    setEditBookForm({ title: book.title, category: book.category, enquiry_details: book.enquiry_details });
  };

  const handleUpdateBookSubmit = async (e, bookId) => {
    e.preventDefault();
    try {
      const payload = {
        title: editBookForm.title,
        category: editBookForm.category,
        enquiry_details: editBookForm.enquiry_details,
        updated_by_user_id: sessionUser.id
      };

      const res = await fetch(`https://metapi.emedhatechnologies.com/api/students/put/books/${bookId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      const result = await res.json();
      if (result.success) {
        setEditingBookId(null);
        handleOpenBooksModal(selectedStudent); // Refresh list
      }
    } catch (err) {
      console.error("Failed to update book:", err);
    }
  };

  // --- INTEGRATED DOCUMENT MODAL HANDLERS ---
  const handleOpenDocsModal = async (student) => {
    setSelectedStudent(student);
    setIsAddingDoc(false);
    setEditingDocId(null);
    setIsDocsModalOpen(true);

    try {
      const res = await fetch(`https://metapi.emedhatechnologies.com/api/students/get/documents?studentId=${student.id}`);
      const result = await res.json();
      if (result.success) {
        setStudentDocs(result.data);
      }
    } catch (err) {
      console.error("Failed to fetch documents:", err);
    }
  };



  const handleAddDocSubmit = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      formData.append('student_id', selectedStudent.id);
      formData.append('name', newDocForm.name);
      formData.append('type', newDocForm.type);
      formData.append('status', newDocForm.status);
      formData.append('posted_by_user_id', sessionUser.id);
      formData.append('posted_by_name', sessionUser.name);
      formData.append('posted_by_role', sessionUser.role);
      const fileInput = document.querySelector('input[type="file"]');
      if (fileInput && fileInput.files[0]) {
        formData.append('file', fileInput.files[0]);
      }
      const res = await fetch('https://metapi.emedhatechnologies.com/api/students/post/documents', {
        method: 'POST',
        body: formData
      });
      const result = await res.json();
      if (result.success) {
        setNewDocForm({ name: '', type: 'PDF', status: 'Verified', fileName: '' });
        setIsAddingDoc(false);
        handleOpenDocsModal(selectedStudent);
      }
    } catch (err) {
      console.error("Failed to upload document:", err);
    }
  };



  const handleStartEditDoc = (doc) => {
    setEditingDocId(doc.id);
    setEditDocForm({ name: doc.name, type: doc.type, status: doc.status, file_name: doc.file_name });
  };

  const handleUpdateDocSubmit = async (e, docId) => {
    e.preventDefault();
    try {
      const payload = {
        name: editDocForm.name,
        type: editDocForm.type,
        status: editDocForm.status,
        file_name: editDocForm.file_name,
        updated_by_user_id: sessionUser.id
      };

      const res = await fetch(`https://metapi.emedhatechnologies.com/api/students/put/documents/${docId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      const result = await res.json();
      if (result.success) {
        setEditingDocId(null);
        handleOpenDocsModal(selectedStudent); // Refresh list
      }
    } catch (err) {
      console.error("Failed to update document:", err);
    }
  };



  const handleDeleteBook = async (bookId) => {
    if (!window.confirm("Are you sure you want to delete this book record?")) return;
    try {
      const res = await fetch(`https://metapi.emedhatechnologies.com/api/students/delete/books/${bookId}`, {
        method: 'DELETE'
      });
      const result = await res.json();
      if (result.success) {
        handleOpenBooksModal(selectedStudent); // Refresh modal data list
      }
    } catch (err) {
      console.error("Failed to delete book:", err);
    }
  };

  const handleDeleteDoc = async (docId) => {
    if (!window.confirm("Are you sure you want to delete this document record?")) return;
    try {
      const res = await fetch(`https://metapi.emedhatechnologies.com/api/students/delete/documents/${docId}`, {
        method: 'DELETE'
      });
      const result = await res.json();
      if (result.success) {
        handleOpenDocsModal(selectedStudent); // Refresh modal data list
      }
    } catch (err) {
      console.error("Failed to delete document:", err);
    }
  };



  const totalPages = Math.ceil(students.length / itemsPerPage) || 1;
  const currentItems = students.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  return (
    <div>
      {/* STEP 1: NAVIGATION AND ACTION HEADER ROW */}
      <div style={styles.topActionBar}>
        <div style={styles.tabScrollGroup}>
          {simpleTabs.map((tab) => {
            const Icon = tab.icon;
            return (
              <button key={tab.id} onClick={() => setActiveTab(tab.id)} style={{ ...styles.tabBtn, ...(activeTab === tab.id ? styles.tabBtnActive : {}) }}>
                <Icon size={15} style={{ marginRight: '6px' }} /> {tab.name}
              </button>
            );
          })}
        </div>
        {/* <button onClick={() => setIsTermModalOpen(true)} style={styles.termAdvanceBtn}>
          <Calendar size={15} style={{ marginRight: '6px' }} /> Assign Year & Semester
        </button> */}
      </div>

      {/* STEP 2: SEARCH FILTERS PANEL */}
      <div style={styles.filterControlPanel}>
        <div style={styles.searchWrapper}>
          <Search size={16} style={styles.searchIcon} />
          <input type="text" placeholder="Search student records..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} style={styles.tableSearchInput} />
        </div>
        <div style={styles.totalIndicator}>Total Students Listed: <strong style={{ color: '#459bf2' }}>{students.length}</strong></div>
      </div>

      {/* STEP 3: MASTER DATA GRID TABLE */}
      {tableLoading ? (
        <div style={{ display: 'flex', justifyContent: 'center', padding: '40px' }}><Loader2 size={32} style={{ animation: 'spin 1s linear infinite' }} color="#459bf2" /></div>
      ) : (
        <div style={{ overflowX: 'auto', width: '100%' }}>
          <table style={styles.dataTable}>
            <thead>
              <tr>
                <th style={styles.tableTh}>Admission No.</th>
                <th style={styles.tableTh}>Student Full Name</th>
                <th style={styles.tableTh}>Contact Mobile</th>
                <th style={styles.tableTh}>Assigned Course</th>
                <th style={styles.tableTh}>College Name / Campus</th>
                <th style={styles.tableTh}>Highest Qualification</th>
                <th style={styles.tableTh}>Aadhaar Number</th>
                <th style={styles.tableTh}>Academic Year & Semester</th>
                <th style={styles.tableTh}>Created By</th>
                <th style={styles.tableTh}>Credential Status</th>
                <th style={styles.tableTh}>System Login Actions</th>
                <th style={styles.tableTh}>Books</th>
                <th style={styles.tableTh}>Documents</th>
                <th style={styles.tableTh}>Assignment</th>
              </tr>
            </thead>
            <tbody>
              {currentItems.map((std) => (
                <tr key={std.id} style={std.is_account_active === 0 ? styles.tableTrDisabled : styles.tableTr}>
                  <td style={{ ...styles.tableTd, fontWeight: '700', color: '#0f172a' }}>{std.roll_number || `MET-ADM-${std.id}`}</td>
                  <td style={styles.tableTd}><strong>{std.name}</strong><br /><small style={{ color: '#64748b' }}>{std.email}</small></td>
                  <td style={styles.tableTd}>{std.mobile}</td>
                  <td style={styles.tableTd}><span style={styles.courseBadge}>{std.target_course}</span></td>
                  <td style={styles.tableTd}>{std.college_university}</td>
                  <td style={styles.tableTd}>{std.highest_qualification || 'XII'}</td>
                  <td style={styles.tableTd}>[Aadhaar Redacted]</td>
                  <td style={styles.tableTd}>
                    <div style={{ fontWeight: '600', color: '#334155' }}>{std.current_semester}</div>
                    <div style={{ fontSize: '11px', color: '#64748b', marginTop: '2px' }}>Academic Year: {std.academic_year}</div>
                  </td>
                  <td style={styles.tableTd}><span style={{ fontSize: '12px', fontWeight: '500' }}>{std.created_by_name}</span></td>
                  <td style={styles.tableTd}>
                    {std.login_access_provisioned === 1 ? (
                      <span style={std.is_account_active === 1 ? styles.secureBadge : styles.inactiveBadge}>
                        {std.is_account_active === 1 ? "Account Live" : "Account Suspended"}
                      </span>
                    ) : (
                      <span style={styles.pendingBadge}>Pending Setup</span>
                    )}
                  </td>
                  <td style={styles.tableTd}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      {std.login_access_provisioned === 0 ? (
                        <button onClick={() => handleCreateCredentialsClick(std)} style={styles.provisionBtn}>Create Logins</button>
                      ) : (
                        <button onClick={() => handleToggleAccountAccess(std.id, std.is_account_active === 1)} style={std.is_account_active === 1 ? styles.deactivateBtn : styles.activateBtn}>
                          {std.is_account_active === 1 ? "Deactivate Access" : "Activate Access"}
                        </button>
                      )}
                    </div>
                  </td>
                  <td style={styles.tableTd}>
                    <button onClick={() => handleOpenBooksModal(std)} style={styles.iconButton} title="View Books & Enquiries">
                      <BookOpen size={16} color="#2563eb" />
                    </button>
                  </td>
                  <td style={styles.tableTd}>
                    <button onClick={() => handleOpenDocsModal(std)} style={styles.iconButton} title="View Documents">
                      <FileText size={16} color="#059669" />
                    </button>
                  </td>
                  <td style={styles.tableTd}>
  <button onClick={() => handleOpenAssignmentsModal(std)} style={styles.iconButton} title="View Assignments & Projects">
    <ClipboardList size={16} color="#d97706" />
  </button>
</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* STEP 4: PAGINATION BAR CONTAINER */}
      <div style={styles.paginationBar}>
        <span style={{ color: '#64748b', fontSize: '13px' }}>Page {currentPage} of {totalPages}</span>
        <div style={{ display: 'flex', gap: '8px' }}>
          <button disabled={currentPage === 1} onClick={() => setCurrentPage(currentPage - 1)} style={{ ...styles.pagBtn, ...(currentPage === 1 && styles.pagBtnDisabled) }}>Previous</button>
          <button disabled={currentPage === totalPages} onClick={() => setCurrentPage(currentPage + 1)} style={{ ...styles.pagBtn, ...(currentPage === totalPages && styles.pagBtnDisabled) }}>Next</button>
        </div>
      </div>

      {/* MODAL 1: LOGIN PROVISIONING */}
      {isAuthModalOpen && (
        <div style={styles.modalBackdrop}>
          <div style={{ ...styles.modalWrapperCard, maxWidth: '420px' }}>
            <div style={styles.modalHeader}>
              <h3 style={{ margin: 0, fontSize: '15px' }}>Student Login Created</h3>
              <button onClick={() => setIsAuthModalOpen(false)} style={styles.modalCloseX}><X size={18} /></button>
            </div>
            <div style={{ padding: '16px 0', display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <p style={{ fontSize: '13.5px', color: '#475569', margin: 0 }}>Logins ready for: <strong>{selectedStudent?.name}</strong></p>
              <div style={styles.credsContainerBox}>
                <div style={styles.credRow}><span>Student Username:</span> <strong>{generatedCreds?.username}</strong></div>
                <div style={styles.credRow}><span>Default Password:</span> <strong>{generatedCreds?.password}</strong></div>
              </div>
              <button onClick={() => { navigator.clipboard.writeText(`User: ${generatedCreds.username} | Pass: ${generatedCreds.password}`); alert("Copied!"); }} style={styles.copyBtn}><ClipboardCheck size={14} /> Copy Credentials</button>
            </div>
            <div style={styles.formActionDock}>
              <button onClick={() => setIsAuthModalOpen(false)} style={styles.formCancelBtn}>Cancel</button>
              <button onClick={saveCredentialsToDatabase} style={styles.formSaveBtn}>Activate Access Account</button>
            </div>
          </div>
        </div>
      )}

      {/* MODAL 2: ASSIGN ACADEMIC YEAR & SEMESTER */}
      {isTermModalOpen && (
        <div style={styles.modalBackdrop}>
          <div style={styles.modalWrapperCard}>
            <div style={styles.modalHeader}>
              <h3 style={{ margin: 0, fontSize: '15px' }}>Assign Academic Year & Semester Settings</h3>
              <button onClick={() => setIsTermModalOpen(false)} style={styles.modalCloseX}><X size={18} /></button>
            </div>
            <form onSubmit={handleTermAssignmentSubmit} style={styles.modalForm}>
              <div style={styles.formSplitGrid}>
                <div style={styles.fieldContainer}>
                  <label style={styles.fieldLabel}>Select Target Course</label>
                  <select value={termForm.targetCourse} onChange={(e) => setTermForm({ ...termForm, targetCourse: e.target.value })} style={styles.formSelect}>
                    <option>React FullStack</option><option>Data Science & AI</option><option>Cyber Security Master</option>
                  </select>
                </div>
                <div style={styles.fieldContainer}>
                  <label style={styles.fieldLabel}>Assign to Semester</label>
                  <select value={termForm.nextSemester} onChange={(e) => setTermForm({ ...termForm, nextSemester: e.target.value })} style={styles.formSelect}>
                    <option>Semester 1</option><option>Semester 2</option><option>Semester 3</option><option>Semester 4</option><option>Semester 5</option><option>Semester 6</option><option>Semester 7</option><option>Semester 8</option>
                  </select>
                </div>
              </div>
              <div style={styles.fieldContainer}><label style={styles.fieldLabel}>Assign Academic Year</label><input type="text" required value={termForm.nextAcademicYear} onChange={(e) => setTermForm({ ...termForm, nextAcademicYear: e.target.value })} style={styles.formInput} placeholder="e.g. 2026-2027" /></div>
              <div style={styles.formActionDock}>
                <button type="button" onClick={() => setIsTermModalOpen(false)} style={styles.formCancelBtn}>Cancel</button>
                <button type="submit" style={{ ...styles.formSaveBtn, background: 'linear-gradient(90deg, #459bf2 0%, #1c6ec9 100%)' }}>Save Academic Setup</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* MODAL 3: STUDENT BOOKS */}
      {isBooksModalOpen && (
        <div style={styles.modalBackdrop}>
          <div style={{ ...styles.modalWrapperCard, maxWidth: '850px' }}>
            <div style={styles.modalHeader}>
              <h3 style={{ margin: 0, fontSize: '15px' }}>Assigned Books & Enquiries - {selectedStudent?.name}</h3>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <button onClick={() => { setIsAddingBook(!isAddingBook); setEditingBookId(null); }} style={styles.addBookBtn}>
                  <Plus size={14} /> {isAddingBook ? 'Cancel Add' : 'Add New Book'}
                </button>
                <button onClick={() => setIsBooksModalOpen(false)} style={styles.modalCloseX}><X size={18} /></button>
              </div>
            </div>

         {isAddingBook && (
  <form onSubmit={handleAddBookSubmit} style={styles.inlineAddForm}>
    <div style={styles.formSplitGrid}>
      {/* 1. SELECT COURSE (From Student's enrolled courses) */}
      <div style={styles.fieldContainer}>
        <label style={styles.fieldLabel}>Select Enrolled Course</label>
        <select 
          value={newBookForm.course_name} 
          onChange={(e) => setNewBookForm({ ...newBookForm, course_name: e.target.value })} 
          style={styles.formSelect}
        >
          {selectedStudent?.target_course?.split(',').map((cStr, idx) => (
            <option key={idx} value={cStr.trim()}>{cStr.trim()}</option>
          ))}
        </select>
      </div>

      {/* 2. SELECT SEMESTER / TERM */}
      <div style={styles.fieldContainer}>
        <label style={styles.fieldLabel}>Select Semester / Term</label>
        <select 
          value={newBookForm.term_label} 
          onChange={(e) => setNewBookForm({ ...newBookForm, term_label: e.target.value })} 
          style={styles.formSelect}
        >
          <option>Semester 1</option>
          <option>Semester 2</option>
          <option>Semester 3</option>
          <option>Semester 4</option>
          <option>Semester 5</option>
          <option>Semester 6</option>
          <option>Year 1</option>
          <option>Year 2</option>
          <option>Year 3</option>
        </select>
      </div>
    </div>

    <div style={styles.formSplitGrid}>
      {/* 3. DATE SENT */}
      <div style={styles.fieldContainer}>
        <label style={styles.fieldLabel}>Date Sent / Dispatched</label>
        <input 
          type="date" 
          required 
          value={newBookForm.sent_date} 
          onChange={(e) => setNewBookForm({ ...newBookForm, sent_date: e.target.value })} 
          style={styles.formInput} 
        />
      </div>

      {/* 4. COURIER & TRACKING DETAILS */}
      <div style={styles.fieldContainer}>
        <label style={styles.fieldLabel}>Courier & Tracking Details</label>
        <input 
          type="text" 
          required 
          placeholder="e.g. Professional Courier - Pod No: 874512" 
          value={newBookForm.courier_details} 
          onChange={(e) => setNewBookForm({ ...newBookForm, courier_details: e.target.value })} 
          style={styles.formInput} 
        />
      </div>
    </div>

    {/* 5. REMARKS / ISSUE NOTES */}
    <div style={styles.fieldContainer}>
      <label style={styles.fieldLabel}>Remarks / Dispatch Notes</label>
      <input 
        type="text" 
        placeholder="e.g. All 5 Subject Textbooks Included" 
        value={newBookForm.enquiryDetails} 
        onChange={(e) => setNewBookForm({ ...newBookForm, enquiryDetails: e.target.value })} 
        style={styles.formInput} 
      />
    </div>

    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '4px' }}>
      <button type="submit" style={styles.formSaveBtn}>Save Dispatch Record</button>
    </div>
  </form>
)}

            <div style={{ padding: '16px 0', overflowX: 'auto', maxHeight: '50vh' }}>
              <table style={styles.dataTable}>
              <thead>
  <tr>
    <th style={styles.tableTh}>ID</th>
    <th style={styles.tableTh}>Course & Term</th>
    <th style={styles.tableTh}>Date Sent</th>
    <th style={styles.tableTh}>Courier & Tracking Info</th>
    <th style={styles.tableTh}>Remarks</th>
    <th style={styles.tableTh}>Actions</th>
  </tr>
</thead>
<tbody>
  {studentBooks.length === 0 ? (
    <tr><td colSpan="6" style={{ textAlign: 'center', padding: '20px', color: '#94a3b8' }}>No material dispatches logged yet.</td></tr>
  ) : (
    studentBooks.map((book) => (
      <tr key={book.id} style={styles.tableTr}>
        <td style={{ ...styles.tableTd, fontWeight: '700' }}>DSP-{book.id}</td>
        <td style={styles.tableTd}>
          <strong>{book.course_name}</strong><br />
          <span style={styles.courseBadge}>{book.term_label}</span>
        </td>
        <td style={styles.tableTd}>{book.sent_date ? book.sent_date.split('T')[0] : '-'}</td>
        <td style={styles.tableTd}>
          <strong style={{ color: '#0f172a' }}>{book.courier_details || 'Hand Delivery'}</strong>
        </td>
        <td style={styles.tableTd}>{book.enquiry_details}</td>
        <td style={styles.tableTd}>
          <button onClick={() => handleDeleteBook(book.id)} style={styles.iconButton} title="Delete Record">
            <Trash2 size={14} color="#dc2626" />
          </button>
        </td>
      </tr>
    ))
  )}
</tbody>
              </table>
            </div>
            <div style={styles.formActionDock}>
              <button onClick={() => setIsBooksModalOpen(false)} style={styles.formSaveBtn}>Close Window</button>
            </div>
          </div>
        </div>
      )}

      {/* MODAL 4: STUDENT DOCUMENTS (WITH FILE UPLOAD / FILE INPUTS) */}
      {isDocsModalOpen && (
        <div style={styles.modalBackdrop}>
          <div style={{ ...styles.modalWrapperCard, maxWidth: '800px' }}>
            <div style={styles.modalHeader}>
              <h3 style={{ margin: 0, fontSize: '15px' }}>Verified Documents - {selectedStudent?.name}</h3>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <button onClick={() => { setIsAddingDoc(!isAddingDoc); setEditingDocId(null); }} style={styles.addBookBtn}>
                  <Plus size={14} /> {isAddingDoc ? 'Cancel Add' : 'Upload New Document'}
                </button>
                <button onClick={() => setIsDocsModalOpen(false)} style={styles.modalCloseX}><X size={18} /></button>
              </div>
            </div>

            {/* Inline Add & File Upload Document Form Drawer */}
            {isAddingDoc && (
              <form onSubmit={handleAddDocSubmit} style={styles.inlineAddForm}>
                <div style={styles.formSplitGrid}>
                  <div style={styles.fieldContainer}>
                    <label style={styles.fieldLabel}>Document Name</label>
                    <input type="text" required placeholder="e.g. Graduation Degree" value={newDocForm.name} onChange={(e) => setNewDocForm({ ...newDocForm, name: e.target.value })} style={styles.formInput} />
                  </div>
                  <div style={styles.fieldContainer}>
                    <label style={styles.fieldLabel}>Document Type</label>
                    <select value={newDocForm.type} onChange={(e) => setNewDocForm({ ...newDocForm, type: e.target.value })} style={styles.formSelect}>
                      <option>PDF</option><option>Image / PNG</option><option>DOCX</option>
                    </select>
                  </div>
                </div>

                <div style={styles.formSplitGrid}>
                  <div style={styles.fieldContainer}>
                    <label style={styles.fieldLabel}>Verification Status</label>
                    <select value={newDocForm.status} onChange={(e) => setNewDocForm({ ...newDocForm, status: e.target.value })} style={styles.formSelect}>
                      <option>Verified</option><option>Pending Review</option><option>Rejected</option>
                    </select>
                  </div>
                  <div style={styles.fieldContainer}>
                    <label style={styles.fieldLabel}>Choose File Upload</label>
                    <div style={styles.fileInputWrapper}>
                      <input
                        type="file"
                        onChange={(e) => {
                          if (e.target.files[0]) {
                            setNewDocForm({ ...newDocForm, fileName: e.target.files[0].name });
                          }
                        }}
                        style={styles.fileInputElement}
                      />
                      <span style={{ fontSize: '12px', color: '#64748b', display: 'flex', alignItems: 'center', gap: '6px' }}>
                        <Upload size={14} color="#2563eb" /> {newDocForm.fileName || 'Select file from device...'}
                      </span>
                    </div>
                  </div>
                </div>

                <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '4px' }}>
                  <button type="submit" style={styles.formSaveBtn}>Upload & Save Document</button>
                </div>
              </form>
            )}

            <div style={{ padding: '16px 0', overflowX: 'auto', maxHeight: '50vh' }}>
              <table style={styles.dataTable}>
                <thead>
                  <tr>
                    <th style={styles.tableTh}>Doc ID</th>
                    <th style={styles.tableTh}>Document Name & File</th>
                    <th style={styles.tableTh}>Type</th>
                    <th style={styles.tableTh}>Verification Status</th>
                    <th style={styles.tableTh}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {studentDocs.length === 0 ? (
                    <tr><td colSpan="5" style={{ textAlign: 'center', padding: '20px', color: '#94a3b8' }}>No documents added yet.</td></tr>
                  ) : (
                    studentDocs.map((doc) => (
                      <tr key={doc.id} style={styles.tableTr}>
                        <td style={styles.tableTd}>DOC-{doc.id}</td>
                        <td style={styles.tableTd}>
                          {editingDocId === doc.id ? (
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                              <input type="text" value={editDocForm.name} onChange={(e) => setEditDocForm({ ...editDocForm, name: e.target.value })} style={styles.formInput} />
                            </div>
                          ) : (
                            <>
                              <strong>{doc.name}</strong><br />
                              <small style={{ color: '#2563eb', textDecoration: 'underline' }}>{doc.file_name || 'document.pdf'}</small>
                            </>
                          )}
                        </td>
                        <td style={styles.tableTd}>
                          {editingDocId === doc.id ? (
                            <select value={editDocForm.type} onChange={(e) => setEditDocForm({ ...editDocForm, type: e.target.value })} style={styles.formSelect}>
                              <option>PDF</option><option>Image / PNG</option><option>DOCX</option>
                            </select>
                          ) : (
                            doc.type
                          )}
                        </td>
                        <td style={styles.tableTd}>
                          {editingDocId === doc.id ? (
                            <select value={editDocForm.status} onChange={(e) => setEditDocForm({ ...editDocForm, status: e.target.value })} style={styles.formSelect}>
                              <option>Verified</option><option>Pending Review</option><option>Rejected</option>
                            </select>
                          ) : (
                            <span style={styles.secureBadge}>{doc.status}</span>
                          )}
                        </td>
                        <td style={styles.tableTd}>
                          <div style={{ display: 'flex', gap: '6px' }}>
                            {editingDocId === doc.id ? (
                              <button onClick={(e) => handleUpdateDocSubmit(e, doc.id)} style={styles.editActionBtn} title="Save Edit">
                                <Check size={14} color="#059669" />
                              </button>
                            ) : (
                              <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                <button onClick={() => handleStartEditDoc(doc)} style={styles.iconButton} title="Edit Record">
                                  <Edit3 size={14} color="#2563eb" />
                                </button>
                                <button onClick={() => handleDeleteDoc(doc.id)} style={styles.iconButton} title="Delete Document">
                                  <Trash2 size={14} color="#dc2626" />
                                </button>
                              </div>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
            <div style={styles.formActionDock}>
              <button onClick={() => setIsDocsModalOpen(false)} style={styles.formSaveBtn}>Close</button>
            </div>
          </div>
        </div>
      )}


      {/* MODAL 5: STUDENT ASSIGNMENTS & PROJECTS */}
{isAssignmentsModalOpen && (
  <div style={styles.modalBackdrop}>
    <div style={{ ...styles.modalWrapperCard, maxWidth: '850px' }}>
      <div style={styles.modalHeader}>
        <h3 style={{ margin: 0, fontSize: '15px' }}>Assignments & Project Submissions - {selectedStudent?.name}</h3>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <button onClick={() => setIsAddingAssignment(!isAddingAssignment)} style={styles.addBookBtn}>
            <Plus size={14} /> {isAddingAssignment ? 'Cancel Add' : 'Record New Submission'}
          </button>
          <button onClick={() => setIsAssignmentsModalOpen(false)} style={styles.modalCloseX}><X size={18} /></button>
        </div>
      </div>

      {/* Inline Form to Add Assignment */}
      {isAddingAssignment && (
        <form onSubmit={handleAddAssignmentSubmit} style={styles.inlineAddForm}>
          <div style={styles.formSplitGrid}>
            <div style={styles.fieldContainer}>
              <label style={styles.fieldLabel}>Select Enrolled Course *</label>
              <select 
                value={newAssignmentForm.course_name} 
                onChange={(e) => setNewAssignmentForm({ ...newAssignmentForm, course_name: e.target.value })} 
                style={styles.formSelect}
              >
                {selectedStudent?.target_course?.split(',').map((cStr, idx) => (
                  <option key={idx} value={cStr.trim()}>{cStr.trim()}</option>
                ))}
              </select>
            </div>

            <div style={styles.fieldContainer}>
              <label style={styles.fieldLabel}>Select Semester / Term *</label>
              <select 
                value={newAssignmentForm.term_label} 
                onChange={(e) => setNewAssignmentForm({ ...newAssignmentForm, term_label: e.target.value })} 
                style={styles.formSelect}
              >
                <option>Semester 1</option><option>Semester 2</option><option>Semester 3</option><option>Semester 4</option>
                <option>Semester 5</option><option>Semester 6</option><option>Year 1</option><option>Year 2</option><option>Year 3</option>
              </select>
            </div>
          </div>

          <div style={styles.formSplitGrid}>
            <div style={styles.fieldContainer}>
              <label style={styles.fieldLabel}>Project / Assignment Title (Optional)</label>
              <input 
                type="text" 
                placeholder="e.g. Marketing Research Paper / Case Study" 
                value={newAssignmentForm.project_title} 
                onChange={(e) => setNewAssignmentForm({ ...newAssignmentForm, project_title: e.target.value })} 
                style={styles.formInput} 
              />
            </div>

            <div style={styles.fieldContainer}>
              <label style={styles.fieldLabel}>Submission Date *</label>
              <input 
                type="date" 
                required 
                value={newAssignmentForm.submission_date} 
                onChange={(e) => setNewAssignmentForm({ ...newAssignmentForm, submission_date: e.target.value })} 
                style={styles.formInput} 
              />
            </div>
          </div>

          <div style={styles.formSplitGrid}>
            <div style={styles.fieldContainer}>
              <label style={styles.fieldLabel}>Completion Status *</label>
              <select 
                value={newAssignmentForm.is_completed ? 'true' : 'false'} 
                onChange={(e) => setNewAssignmentForm({ ...newAssignmentForm, is_completed: e.target.value === 'true' })} 
                style={styles.formSelect}
              >
                <option value="true">Yes - Completed / Submitted</option>
                <option value="false">No - Pending / Incomplete</option>
              </select>
            </div>

            <div style={styles.fieldContainer}>
              <label style={styles.fieldLabel}>Remarks / Remarks Notes</label>
              <input 
                type="text" 
                placeholder="e.g. Evaluated with 22/25 marks" 
                value={newAssignmentForm.remarks} 
                onChange={(e) => setNewAssignmentForm({ ...newAssignmentForm, remarks: e.target.value })} 
                style={styles.formInput} 
              />
            </div>
          </div>

          <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '4px' }}>
            <button type="submit" style={styles.formSaveBtn}>Save Assignment Record</button>
          </div>
        </form>
      )}

      {/* Submitted Assignments Data Table */}
      <div style={{ padding: '16px 0', overflowX: 'auto', maxHeight: '50vh' }}>
        <table style={styles.dataTable}>
          <thead>
            <tr>
              <th style={styles.tableTh}>ID</th>
              <th style={styles.tableTh}>Course & Term</th>
              <th style={styles.tableTh}>Project / Assignment Title</th>
              <th style={styles.tableTh}>Submission Date</th>
              <th style={styles.tableTh}>Status</th>
              <th style={styles.tableTh}>Remarks</th>
              <th style={styles.tableTh}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {studentAssignments.length === 0 ? (
              <tr><td colSpan="7" style={{ textAlign: 'center', padding: '20px', color: '#94a3b8' }}>No assignments recorded for this student yet.</td></tr>
            ) : (
              studentAssignments.map((ass) => (
                <tr key={ass.id} style={styles.tableTr}>
                  <td style={{ ...styles.tableTd, fontWeight: '700' }}>ASN-{ass.id}</td>
                  <td style={styles.tableTd}>
                    <strong>{ass.course_name}</strong><br />
                    <span style={styles.courseBadge}>{ass.term_label}</span>
                  </td>
                  <td style={styles.tableTd}>{ass.project_title || 'General Term Assignment'}</td>
                  <td style={styles.tableTd}>{ass.submission_date ? ass.submission_date.split('T')[0] : '-'}</td>
                  <td style={styles.tableTd}>
                    <span style={ass.is_completed === 1 ? styles.secureBadge : styles.inactiveBadge}>
                      {ass.is_completed === 1 ? "✓ Submitted" : "Pending"}
                    </span>
                  </td>
                  <td style={styles.tableTd}>{ass.remarks || '-'}</td>
                  <td style={styles.tableTd}>
                    <button onClick={() => handleDeleteAssignment(ass.id)} style={styles.iconButton} title="Delete Record">
                      <Trash2 size={14} color="#dc2626" />
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <div style={styles.formActionDock}>
        <button onClick={() => setIsAssignmentsModalOpen(false)} style={styles.formSaveBtn}>Close Window</button>
      </div>
    </div>
  </div>
)}


    </div>
  );
}

const styles = {
  topActionBar: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '16px', marginBottom: '20px', flexWrap: 'wrap' },
  tabScrollGroup: { display: 'flex', gap: '8px', overflowX: 'auto', paddingBottom: '4px' },
  tabBtn: { display: 'inline-flex', alignItems: 'center', padding: '10px 16px', background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '10px', color: '#64748b', fontSize: '13.5px', fontWeight: '500', cursor: 'pointer', whiteSpace: 'nowrap', transition: 'all 0.2s' },
  tabBtnActive: { background: 'linear-gradient(135deg, #459bf2 0%, #1c6ec9 100%)', borderColor: '#459bf2', color: '#ffffff', boxShadow: '0 4px 12px rgba(69, 155, 242, 0.15)' },
  termAdvanceBtn: { background: 'linear-gradient(90deg, #e30504 0%, #a80302 100%)', border: 'none', borderRadius: '12px', color: '#fff', padding: '12px 20px', fontSize: '13px', fontWeight: '700', cursor: 'pointer', display: 'flex', alignItems: 'center', whiteSpace: 'nowrap' },
  filterControlPanel: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '16px', marginBottom: '16px', flexWrap: 'wrap', borderBottom: '1px solid #edf2f7', paddingBottom: '14px' },
  searchWrapper: { position: 'relative', display: 'flex', alignItems: 'center', flex: 1, maxWidth: '300px', width: '100%' },
  searchIcon: { position: 'absolute', left: '12px', color: '#94a3b8' },
  tableSearchInput: { width: '100%', padding: '9px 12px 9px 36px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '9px', color: '#0f172a', fontSize: '13.5px', outline: 'none' },
  totalIndicator: { fontSize: '14.5px', fontWeight: '600', color: '#334155' },
  dataTable: { width: '100%', borderCollapse: 'collapse', textAlign: 'left' },
  tableTh: { padding: '12px 14px', borderBottom: '2px solid #e2e8f0', color: '#64748b', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.5px', fontWeight: '600', whiteSpace: 'nowrap' },
  tableTr: { borderBottom: '1px solid #f1f5f9', background: '#ffffff' },
  tableTrDisabled: { borderBottom: '1px solid #f1f5f9', background: '#fff1f2', opacity: 0.85 },
  tableTd: { padding: '12px 14px', color: '#475569', fontSize: '13px', verticalAlign: 'middle', whiteSpace: 'nowrap' },
  courseBadge: { background: '#eff6ff', border: '1px solid #bfdbfe', color: '#1e40af', padding: '4px 8px', borderRadius: '6px', fontSize: '12px', fontWeight: '500', display: 'inline-block' },
  iconButton: { background: '#f8fafc', border: '1px solid #cbd5e1', borderRadius: '8px', padding: '6px 10px', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' },
  addBookBtn: { background: '#2563eb', color: '#ffffff', border: 'none', padding: '6px 12px', borderRadius: '8px', fontSize: '12px', fontWeight: '600', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: '6px' },
  editActionBtn: { background: '#dcfce7', border: 'none', padding: '6px', borderRadius: '6px', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' },
  inlineAddForm: { background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '12px', padding: '12px', marginTop: '10px', display: 'flex', flexDirection: 'column', gap: '10px' },
  fileInputWrapper: { position: 'relative', overflow: 'hidden', display: 'inline-block', width: '100%', background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '8px', padding: '9px 12px', boxSizing: 'border-box' },
  fileInputElement: { position: 'absolute', left: 0, top: 0, opacity: 0, width: '100%', height: '100%', cursor: 'pointer' },
  secureBadge: { display: 'inline-flex', padding: '4px 8px', background: '#dcfce7', border: '1px solid #bbf7d0', color: '#15803d', borderRadius: '6px', fontSize: '11.5px', fontWeight: '600' },
  inactiveBadge: { display: 'inline-flex', padding: '4px 8px', background: '#fee2e2', border: '1px solid #fecaca', color: '#b91c1c', borderRadius: '6px', fontSize: '11.5px', fontWeight: '600' },
  pendingBadge: { display: 'inline-flex', padding: '4px 8px', background: '#f1f5f9', border: '1px solid #cbd5e1', color: '#475569', borderRadius: '6px', fontSize: '11.5px', fontWeight: '600' },
  provisionBtn: { background: '#ffffff', border: '1px solid #94a3b8', color: '#1e40af', padding: '5px 10px', borderRadius: '6px', fontSize: '11.5px', fontWeight: '600', cursor: 'pointer' },
  activateBtn: { background: '#dcfce7', border: 'none', color: '#15803d', padding: '5px 10px', borderRadius: '6px', fontSize: '11.5px', fontWeight: '600', cursor: 'pointer' },
  deactivateBtn: { background: '#fee2e2', border: 'none', color: '#b91c1c', padding: '5px 10px', borderRadius: '6px', fontSize: '11.5px', fontWeight: '600', cursor: 'pointer' },
  paginationBar: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '20px' },
  pagBtn: { background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '8px', color: '#475569', padding: '6px 14px', fontSize: '13px', cursor: 'pointer', fontWeight: '500' },
  pagBtnDisabled: { opacity: 0.4, cursor: 'not-allowed', background: '#f8fafc' },
  modalBackdrop: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(15, 23, 42, 0.25)', backdropFilter: 'blur(8px)', zIndex: 2000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' },
  modalWrapperCard: { background: '#ffffff', border: '1px solid rgba(255,255,255,0.8)', borderRadius: '20px', width: '100%', maxWidth: '580px', maxHeight: '85vh', padding: '24px', display: 'flex', flexDirection: 'column', boxSizing: 'border-box', boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.05)' },
  modalHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBottom: '12px', borderBottom: '1px solid #e2e8f0' },
  modalCloseX: { background: 'transparent', border: 'none', color: '#94a3b8', cursor: 'pointer' },
  modalForm: { display: 'flex', flexDirection: 'column', gap: '14px', marginTop: '14px' },
  formSplitGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' },
  fieldContainer: { display: 'flex', flexDirection: 'column', gap: '4px' },
  fieldLabel: { color: '#64748b', fontSize: '11px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px' },
  formInput: { width: '100%', padding: '10px 12px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '8px', color: '#0f172a', fontSize: '13px', outline: 'none', boxSizing: 'border-box' },
  formSelect: { padding: '10px 12px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '8px', color: '#0f172a', fontSize: '13px', outline: 'none' },
  credsContainerBox: { background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '12px', padding: '12px', display: 'flex', flexDirection: 'column', gap: '6px' },
  credRow: { display: 'flex', justifyContent: 'space-between', fontSize: '13.5px', color: '#334155' },
  copyBtn: { display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '6px', background: '#f1f5f9', border: '1px solid #cbd5e1', padding: '8px', borderRadius: '8px', fontSize: '12px', fontWeight: '600', color: '#475569', cursor: 'pointer' },
  formActionDock: { display: 'flex', justifyContent: 'flex-end', gap: '12px', marginTop: '8px', borderTop: '1px solid #e2e8f0', paddingTop: '12px' },
  formCancelBtn: { background: 'transparent', border: '1px solid #e2e8f0', color: '#64748b', padding: '9px 16px', borderRadius: '8px', cursor: 'pointer' },
  formSaveBtn: { background: 'linear-gradient(90deg, #10b981 0%, #059669 100%)', border: 'none', color: '#fff', padding: '9px 16px', borderRadius: '8px', fontWeight: '600', cursor: 'pointer' }
};